import React, { useMemo } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { useSiteSettings } from '../hooks/use-site-settings';
import { useLanguage } from '../i18n/LanguageContext';

const splitIntoParagraphs = (value) =>
  String(value || '')
    .replace(/\\n/g, '\n')
    .split(/\n\s*\n/g)
    .map((item) => item.trim())
    .filter(Boolean);

const Terms = () => {
  const { siteSettings } = useSiteSettings();
  const { tr, formatDate, localizeText } = useLanguage();

  const termsParagraphs = useMemo(
    () => splitIntoParagraphs(localizeText(siteSettings.termsOfServiceText)),
    [siteSettings.termsOfServiceText, localizeText],
  );

  return (
    <div className="min-h-screen bg-white">
      <section className="bg-sage-100 py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold text-sage-900 mb-4">{tr('terms.title')}</h1>
          <p className="text-lg text-sage-600">{tr('legal.lastUpdated')} {formatDate(new Date())}</p>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <Card className="border-sage-200 shadow-lg">
            <CardContent className="p-8 space-y-6">
              {termsParagraphs.map((paragraph, index) => (
                <p key={`terms-${index}`} className="text-sage-700 leading-relaxed">
                  {paragraph}
                </p>
              ))}

              <div>
                <h2 className="text-2xl font-bold text-sage-900 mb-4">{tr('terms.contactInfo')}</h2>
                <div className="bg-sage-50 p-4 rounded-lg border border-sage-200">
                  <p className="text-sage-700">
                    <strong>{tr('common.contactByEmail')}</strong> {siteSettings.contactEmail}<br />
                    <strong>{tr('common.contactByPhone')}</strong> {siteSettings.contactPhone}<br />
                    <strong>{tr('common.location')}</strong> {localizeText(siteSettings.locationLabel)}
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default Terms;
